import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { map, take } from 'rxjs/operators';

export const isGlobalEmployee = () => {
  const oidcSecurityService = inject(OidcSecurityService);
  const router = inject(Router);

  return oidcSecurityService.getUserData().pipe(
    take(1),
    map((userData) => {
      if (!userData || userData.UserType !== 'GlobalWarrantyEmployee') {
        router.navigate(['']);
        return false;
      }
      return true;
    }),
  );
};
